module.exports = __webpack_public_path__ + "img/Menu-04.8af628f5.webp";